import React from 'react';
import { motion } from 'framer-motion';
export const HeroSection = () => {
  return <section className="pt-8 pb-10 px-4 md:px-8 bg-brand-cream overflow-hidden" data-id="element-103">
      <div className="max-w-3xl mx-auto flex flex-col items-center text-center" data-id="element-104">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="space-y-4 mb-8" data-id="element-105">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-brand-green leading-tight text-center" data-id="element-106">
            <span className="block" data-id="element-107">No es la edad.</span>
            <span className="block mt-2" data-id="element-108">No es la dieta.</span>
            <span className="block mt-2" data-id="element-109">Son tus hormonas</span>
            <span className="block mt-2" data-id="element-110">Y tienen solución.</span>
          </h1>
          <p className="text-lg md:text-xl text-brand-charcoal/80" data-id="element-111">
            Lo que nadie te explicó sobre tus hormonas a los 45 — y por qué
            ninguna dieta puede funcionar sin esta pieza.
          </p>
        </motion.div>

        <div className="relative mb-8" data-id="element-112">
          <div className="absolute inset-0 bg-brand-gold/10 rounded-full blur-3xl transform scale-90" data-id="element-113"></div>
          <img src="https://cdn.magicpatterns.com/uploads/dpFyDM2gcDHWgCcZXkixzj/Imagen_Producto.webp" alt="Paz Hormonal +40" loading="eager" fetchPriority="high" decoding="async" width="448" height="448" className="relative z-10 w-full max-w-md mx-auto drop-shadow-2xl" data-id="element-114" />
        </div>
      </div>
    </section>;
};